import { PanelColorSettings } from "@wordpress/block-editor";
import {
    ToggleControl,
    SelectControl,
    RangeControl,
    __experimentalUnitControl as UnitControl,
    Flex,
    FlexItem,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
} from "@wordpress/components";

export const commonAttributes = {
    showHoverBar: {
        type: "boolean",
        default: false,
    },
    hoverBarColor: {
        type: "string",
        default: "#000000",
    },
    hoverBarWidth: {
        type: "number",
        default: 100,
    },
    hoverBarWidthUnit: {
        type: "string",
        default: "%",
    },
    hoverBarHeight: {
        type: "number",
        default: 5,
    },
    hoverBarHeightUnit: {
        type: "string",
        default: "px",
    },
    hoverBarAlign: {
        type: "string",
        default: "center",
    },
    borderRadiusTopLeft: {
        type: "number",
        default: 0,
    },
    borderRadiusTopRight: {
        type: "number",
        default: 0,
    },
    borderRadiusBottomLeft: {
        type: "number",
        default: 0,
    },
    borderRadiusBottomRight: {
        type: "number",
        default: 0,
    },
    animation: {
        type: "string",
        default: "fade",
    },
    animationDuration: {
        type: "number",
        default: 0.3,
    },
    groupHoverColor: {
        type: "string",
        default: "transparent",
    },
};

export const HoverBarControls = ({ attributes, setAttributes }) => {
    const {
        showHoverBar,
        hoverBarColor,
        groupHoverColor,
        hoverBarWidth,
        hoverBarWidthUnit,
        hoverBarHeight,
        hoverBarHeightUnit,
        hoverBarAlign,
        borderRadiusTopLeft,
        borderRadiusTopRight,
        borderRadiusBottomLeft,
        borderRadiusBottomRight,
        animation,
        animationDuration,
    } = attributes;

    return (
        <>
            <div style={{ margin: "1vw 0" }}>
                <ToggleControl
                    label="Pokaż hover bar"
                    checked={showHoverBar}
                    onChange={(value) => setAttributes({ showHoverBar: value })}
                    __nextHasNoMarginBottom={true}
                />
            </div>

            {showHoverBar && (
                <>
                    <PanelColorSettings
                        title="Ustawienia kolorów"
                        initialOpen={true}
                        className="custom-panel-color-settings"
                        colorSettings={[
                            {
                                value: groupHoverColor,
                                onChange: (color) =>
                                    setAttributes({ groupHoverColor: color }),
                                label: "Kolor tła",
                            },
                            {
                                value: hoverBarColor,
                                onChange: (color) =>
                                    setAttributes({ hoverBarColor: color }),
                                label: "Kolor hover bar",
                            },
                        ]}
                    />
                    <div style={{ marginBottom: "24px" }}>
                        <Flex>
                            <FlexItem style={{ width: "70%" }}>
                                <RangeControl
                                    label="Szerokość hover bar"
                                    value={hoverBarWidth}
                                    onChange={(value) =>
                                        setAttributes({
                                            hoverBarWidth: value,
                                        })
                                    }
                                    min={0}
                                    max={100}
                                    withInputField={false}
                                    __nextHasNoMarginBottom={true}
                                />
                            </FlexItem>
                            <FlexItem style={{ width: "30%" }}>
                                <UnitControl
                                    value={`${hoverBarWidth}${hoverBarWidthUnit}`}
                                    onChange={(newValue) => {
                                        const numericValue =
                                            parseFloat(newValue);
                                        const unit = newValue.replace(
                                            numericValue,
                                            ""
                                        );
                                        setAttributes({
                                            hoverBarWidth: numericValue,
                                            hoverBarWidthUnit: unit,
                                        });
                                    }}
                                    units={[
                                        { value: "px", label: "px" },
                                        { value: "%", label: "%" },
                                        { value: "em", label: "em" },
                                        { value: "rem", label: "rem" },
                                        { value: "vw", label: "vw" },
                                        { value: "vh", label: "vh" },
                                    ]}
                                />
                            </FlexItem>
                        </Flex>
                    </div>

                    <div style={{ marginBottom: "24px" }}>
                        <Flex>
                            <FlexItem style={{ width: "70%" }}>
                                <RangeControl
                                    label="Wysokość hover bar"
                                    value={hoverBarHeight}
                                    onChange={(value) =>
                                        setAttributes({
                                            hoverBarHeight: value,
                                        })
                                    }
                                    min={0}
                                    max={100}
                                    withInputField={false}
                                    __nextHasNoMarginBottom={true}
                                />
                            </FlexItem>
                            <FlexItem style={{ width: "30%" }}>
                                <UnitControl
                                    value={`${hoverBarHeight}${hoverBarHeightUnit}`}
                                    onChange={(newValue) => {
                                        const numericValue =
                                            parseFloat(newValue);
                                        const unit = newValue.replace(
                                            numericValue,
                                            ""
                                        );
                                        setAttributes({
                                            hoverBarHeight: numericValue,
                                            hoverBarHeightUnit: unit,
                                        });
                                    }}
                                    units={[
                                        { value: "px", label: "px" },
                                        { value: "%", label: "%" },
                                        { value: "em", label: "em" },
                                        { value: "rem", label: "rem" },
                                        { value: "vw", label: "vw" },
                                        { value: "vh", label: "vh" },
                                    ]}
                                />
                            </FlexItem>
                        </Flex>
                    </div>

                    <div style={{ marginBottom: "24px" }}>
                        <SelectControl
                            label="Wyrównanie hover bar"
                            value={hoverBarAlign}
                            options={[
                                { label: "Do lewej", value: "left" },
                                { label: "Wycentrowane", value: "center" },
                                { label: "Do prawej", value: "right" },
                            ]}
                            onChange={(value) =>
                                setAttributes({
                                    hoverBarAlign: value,
                                })
                            }
                        />
                    </div>

                    <ToolsPanel
                        label="Border Radius"
                        style={{ padding: "1vw 0" }}
                        resetAll={() => {
                            setAttributes({
                                borderRadiusTopLeft: 0,
                                borderRadiusTopRight: 0,
                                borderRadiusBottomLeft: 0,
                                borderRadiusBottomRight: 0,
                            });
                        }}
                    >
                        <ToolsPanelItem
                            hasValue={() => borderRadiusTopLeft !== 0}
                            label="Górny lewy róg"
                            onDeselect={() =>
                                setAttributes({
                                    borderRadiusTopLeft: 0,
                                })
                            }
                        >
                            <RangeControl
                                label="Górny lewy róg"
                                value={borderRadiusTopLeft}
                                onChange={(value) =>
                                    setAttributes({
                                        borderRadiusTopLeft: value,
                                    })
                                }
                                min={0}
                                max={50}
                                __nextHasNoMarginBottom={true}
                            />
                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={() => borderRadiusTopRight !== 0}
                            label="Górny prawy róg"
                            onDeselect={() =>
                                setAttributes({
                                    borderRadiusTopRight: 0,
                                })
                            }
                        >
                            <RangeControl
                                label="Górny prawy róg"
                                value={borderRadiusTopRight}
                                onChange={(value) =>
                                    setAttributes({
                                        borderRadiusTopRight: value,
                                    })
                                }
                                min={0}
                                max={50}
                                __nextHasNoMarginBottom={true}
                            />
                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={() => borderRadiusBottomLeft !== 0}
                            label="Dolny lewy róg"
                            onDeselect={() =>
                                setAttributes({
                                    borderRadiusBottomLeft: 0,
                                })
                            }
                        >
                            <RangeControl
                                label="Dolny lewy róg"
                                value={borderRadiusBottomLeft}
                                onChange={(value) =>
                                    setAttributes({
                                        borderRadiusBottomLeft: value,
                                    })
                                }
                                min={0}
                                max={50}
                                __nextHasNoMarginBottom={true}
                            />
                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={() => borderRadiusBottomRight !== 0}
                            label="Dolny prawy róg"
                            onDeselect={() =>
                                setAttributes({
                                    borderRadiusBottomRight: 0,
                                })
                            }
                        >
                            <RangeControl
                                label="Dolny prawy róg"
                                value={borderRadiusBottomRight}
                                onChange={(value) =>
                                    setAttributes({
                                        borderRadiusBottomRight: value,
                                    })
                                }
                                min={0}
                                max={50}
                                __nextHasNoMarginBottom={true}
                            />
                        </ToolsPanelItem>
                    </ToolsPanel>

                    <ToolsPanel
                        style={{
                            padding: "1vw 0",
                            display: "flex",
                            flexDirection: "column",
                        }}
                        resetAll={() => {
                            setAttributes({
                                animation: "fade",
                                animationDuration: 0.3,
                            });
                        }}
                    >
                        <SelectControl
                            label="Animacja"
                            value={animation}
                            options={[
                                { label: "Fade In", value: "fadeIn" },
                                {
                                    label: "Width Animation",
                                    value: "widthAnim",
                                },
                            ]}
                            onChange={(value) =>
                                setAttributes({ animation: value })
                            }
                        />
                        <RangeControl
                            label="Czas trwania animacji (s)"
                            value={animationDuration}
                            onChange={(value) =>
                                setAttributes({
                                    animationDuration: value,
                                })
                            }
                            min={0.1}
                            max={2}
                            step={0.1}
                            __nextHasNoMarginBottom={true}
                        />
                    </ToolsPanel>
                </>
            )}
        </>
    );
};

export const getHoverBarStyle = (attributes) => {
    const {
        hoverBarColor,
        groupHoverColor,
        hoverBarHeight,
        hoverBarHeightUnit,
        hoverBarAlign,
        borderRadiusTopLeft,
        borderRadiusTopRight,
        borderRadiusBottomLeft,
        borderRadiusBottomRight,
        animation,
        animationDuration,
        hoverBarWidth,
        hoverBarWidthUnit,
    } = attributes;

    return {
        position: "absolute",
        bottom: "0",

        background: hoverBarColor || "transparent",
        height: `${hoverBarHeight}${hoverBarHeightUnit}`,
        left:
            hoverBarAlign === "center"
                ? "50%"
                : hoverBarAlign === "right"
                ? "auto"
                : "0",
        right: hoverBarAlign === "right" ? "0" : "auto",
        transform: hoverBarAlign === "center" ? "translateX(-50%)" : "none",
        borderRadius: `${borderRadiusTopLeft}px ${borderRadiusTopRight}px ${borderRadiusBottomRight}px ${borderRadiusBottomLeft}px`,
        zIndex: "10",
        pointerEvents: "none",
        width: "0",
        opacity: animation === "fadeIn" ? 0 : 1,
        transition: `all ${animationDuration}s ease`,
        "--target-width": `${hoverBarWidth}${hoverBarWidthUnit}`,
        "--animation-duration": `${animationDuration}s`,
        "--group-hover-color": `${groupHoverColor}`,
    };
};
